import { Injectable } from '@angular/core';
import { ComparingDatesEnum } from '../enums/comparingDates.enum';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  static compareDatesWhitoutTime(date1: Date, date2: Date, compareEnum: ComparingDatesEnum) {
    let date1ToCompare = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    let date2ToCompare = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    switch (compareEnum) {
      case ComparingDatesEnum.Equal:
        return date1ToCompare.getTime() === date2ToCompare.getTime();

      case ComparingDatesEnum.Bigger:
        return date1ToCompare.getTime() > date2ToCompare.getTime();

      case ComparingDatesEnum.Smaller:
        return date1ToCompare.getTime() < date2ToCompare.getTime();

      default:
        return false;
    }
  }

  static createNewDate(date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  static createNewDateWithTime(date: Date, hour: number, minutes: number) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minutes);
  }

  static createDateWithAddedDays(date: Date, days: number) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  }

  static calculateTotalHoursBetweenDates(date1: Date, date2: Date) {
    let diff = (date2.getTime() - date1.getTime()) / 1000;
    diff /= 3600;
    return Math.round(Math.abs(diff) * 10) / 10;
  }

  static convertDateToString(date: Date) {
    function pad(number: number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    }
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds())
    );
  }

  static checkIfDatesRangeOverlap(startTime1: Date, endTime1: Date, startTime2: Date, endTime2: Date) {
    return startTime1 < endTime2 && startTime2 < endTime1;
  }
}
